import {
  LOGIN_PARTICIPANT_USER,
  LOGIN_PARTICIPANT_SUCCESS,
  LOGOUT_PARTICIPANT_USER,
  LOGOUT_PARTICIPANT_USER_SUCCESS,
  PARTICIPANT_LOGIN_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
}

const loginParticipant = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_PARTICIPANT_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_PARTICIPANT_SUCCESS:
      state = {
        ...state,
        loading: false,
        isUserLogout: false,
      }
      break
    case LOGOUT_PARTICIPANT_USER:
      state = { ...state }
      break
    case LOGOUT_PARTICIPANT_USER_SUCCESS:
      state = { ...state , isUserLogout: true}
      break
    case PARTICIPANT_LOGIN_ERROR:
      state = { ...state, error: action.payload, loading: false,isUserLogout: false, }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default loginParticipant
